import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const COMPANY_INFO = [
  { label: '会社名', value: '株式会社　Y・F・S（ワイエフエス）' },
  { label: '代表者', value: '代表取締役　林　裕次郎' },
  { label: '所在地', value: '〒116-0003 東京都荒川区南千住8－6－2－1113' },
  { label: '設立', value: '2017年9月' },
  { label: '資本金', value: '７７１万円' },
  { label: '電話番号', value: '090-222-8377' },
  { label: 'メールアドレス', value: 'hayashi@y-f-s.jp' },
  { label: '事業内容', value: '集客コンサルティング事業\n営業支援コンサルティング事業' },
  { label: '取引銀行', value: '住信SBI銀行' },
  { label: '顧問', value: '小山武仁税理士事務所' },
];

const BUSINESS_MODEL = [
  { icon: 'ri-calendar-check-line', title: 'コンサルティング契約（月額顧問型）', desc: '毎月継続的に支援を行う顧問契約。安定した収益基盤を構築しています。' },
  { icon: 'ri-flashlight-line', title: 'スポット支援（単発コンサルティング）', desc: '特定の課題解決を目的とした単発コンサルティングサービス。' },
  { icon: 'ri-trophy-line', title: '成果報酬型支援', desc: '案件に応じて成果に連動した報酬設定。お客様とともに成長を目指します。' },
];

const INDUSTRIES = [
  { icon: 'ri-customer-service-line', label: 'サービス業' },
  { icon: 'ri-building-4-line', label: '建設業' },
  { icon: 'ri-computer-line', label: 'IT・Web関連' },
  { icon: 'ri-bank-line', label: '金融・資金調達関連' },
];

const STRENGTHS = [
  '集客から営業まで一貫した支援体制',
  '中小企業に特化した実践的コンサルティング',
  '実務に基づく具体的な改善提案',
  '継続的な運用支援による安定した成果創出',
];

export default function CompanyOverviewPage() {
  return (
    <div className="min-h-screen">
      <Navbar />

      {/* Page Hero */}
      <section className="relative pt-32 pb-16 bg-[#1a2332]">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <span className="text-xs font-semibold tracking-[3px] text-white/40 uppercase">Company Overview</span>
          <h1 className="text-4xl md:text-5xl font-bold text-white mt-3 mb-4">会社概要</h1>

        </div>
      </section>

      {/* Basic Info */}
      <section className="py-20 md:py-28 bg-white">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="mb-12">
            <span className="text-xs font-semibold tracking-[3px] text-gray-400 uppercase">Company Info</span>
            <h2 className="text-3xl font-bold text-[#1a2332] mt-3">会社概要</h2>
          </div>

          <div className="max-w-3xl">
            <table className="w-full border-collapse">
              <tbody>
                {COMPANY_INFO.map((row) => (
                  <tr key={row.label} className="border-b border-gray-100">
                    <th className="text-left py-5 pr-8 text-sm font-semibold text-[#1a2332] w-36 align-top whitespace-nowrap">
                      {row.label}
                    </th>
                    <td className="py-5 text-sm text-gray-600 leading-relaxed whitespace-pre-line">
                      {row.value}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* Business Details */}
      <section className="py-20 bg-[#faf9f7]">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="mb-12">
            <span className="text-xs font-semibold tracking-[3px] text-gray-400 uppercase">Business Details</span>
            <h2 className="text-3xl font-bold text-[#1a2332] mt-3">事業内容</h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
            {[
              {
                icon: 'ri-search-eye-line',
                title: '集客コンサルティング',
                desc: 'Webを中心とした集客戦略の立案・改善支援を行います。SEO対策、広告運用、Webサイト改善などを通じて、安定した見込み顧客の獲得を支援します。',
              },
              {
                icon: 'ri-bar-chart-grouped-line',
                title: '営業支援コンサルティング',
                desc: '営業プロセスの設計および改善を行い、成約率向上を支援します。トークスクリプトの整備や営業フローの構築により、再現性のある営業体制の構築をサポートします。',
              },
              {
                icon: 'ri-refresh-line',
                title: '継続支援・運用改善',
                desc: 'KPIの設定および数値分析を行い、継続的な改善提案を実施します。事業の成長段階に応じた中長期的な支援を提供しています。',
              },
            ].map((item) => (
              <div key={item.title} className="bg-white rounded-2xl p-8">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-[#1a2332]/10 mb-5">
                  <i className={`${item.icon} text-xl text-[#1a2332]`} />
                </div>
                <h3 className="text-base font-bold text-[#1a2332] mb-3">{item.title}</h3>
                <p className="text-sm text-gray-600 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Business Model */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="mb-12">
            <span className="text-xs font-semibold tracking-[3px] text-gray-400 uppercase">Business Model</span>
            <h2 className="text-3xl font-bold text-[#1a2332] mt-3">ビジネスモデル</h2>
            <p className="text-sm text-gray-500 mt-3 max-w-xl">
              継続契約を中心とした安定的な収益基盤を構築し、長期的な取引関係を重視しています。
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {BUSINESS_MODEL.map((bm, i) => (
              <div key={bm.title} className="relative bg-[#faf9f7] rounded-2xl p-8">
                <div className="absolute top-6 right-6 text-4xl font-bold text-[#1a2332]/5">
                  0{i + 1}
                </div>
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-[#1a2332] mb-5">
                  <i className={`${bm.icon} text-xl text-white`} />
                </div>
                <h3 className="text-base font-bold text-[#1a2332] mb-3">{bm.title}</h3>
                <p className="text-sm text-gray-600 leading-relaxed">{bm.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Strengths */}
      <section className="py-20 bg-[#faf9f7]">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Strengths */}
            <div>
              <span className="text-xs font-semibold tracking-[3px] text-gray-400 uppercase">Strengths</span>
              <h2 className="text-2xl md:text-3xl font-bold text-[#1a2332] mt-3 mb-8">強み・特徴</h2>
              <ul className="space-y-4">
                {STRENGTHS.map((s) => (
                  <li key={s} className="flex items-start gap-3 bg-white rounded-xl px-5 py-4">
                    <i className="ri-check-double-line text-[#1a2332] text-lg flex-shrink-0 mt-0.5" />
                    <span className="text-sm font-medium text-[#1a2332]">{s}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Industries */}
            <div>
              <span className="text-xs font-semibold tracking-[3px] text-gray-400 uppercase">Track Record</span>
              <h2 className="text-2xl md:text-3xl font-bold text-[#1a2332] mt-3 mb-4">取引実績</h2>
              <p className="text-sm text-gray-600 leading-relaxed mb-6">
                中小企業・個人事業主を中心に、幅広い業種に対する集客および営業支援を実施しております。
              </p>
              <div className="grid grid-cols-2 gap-3 mb-5">
                {INDUSTRIES.map((ind) => (
                  <div key={ind.label} className="flex items-center gap-3 bg-white rounded-xl px-5 py-4">
                    <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-[#1a2332]/10">
                      <i className={`${ind.icon} text-[#1a2332]`} />
                    </div>
                    <span className="text-sm font-medium text-[#1a2332]">{ind.label}</span>
                  </div>
                ))}
              </div>
              <p className="text-xs text-gray-400">
                ※個別の企業名については守秘義務により非公開とさせていただいております
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Representative Profile */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 items-start">
            <div>
              <div className="rounded-2xl overflow-hidden aspect-[3/4]">
                <img
                  src="https://y-f-s.jp/img/CEO.jpeg"
                  alt="代表取締役 林 裕次郎"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="mt-4 text-center">
                <div className="text-xs text-gray-400">代表取締役</div>
                <div className="text-xl font-bold text-[#1a2332] mt-1">林　裕次郎</div>
                <div className="text-sm text-gray-500">株式会社Y・F・S</div>
              </div>
            </div>
            <div className="lg:col-span-2">
              <span className="text-xs font-semibold tracking-[3px] text-gray-400 uppercase">Profile</span>
              <h2 className="text-2xl md:text-3xl font-bold text-[#1a2332] mt-3 mb-6">代表プロフィール</h2>
              <div className="space-y-4 text-sm text-gray-600 leading-relaxed">
                <p>
                  営業およびWebマーケティング領域における実務経験を基に、
                  中小企業の売上改善に特化したコンサルティング事業を展開。
                </p>
                <p>
                  これまで、集客導線の最適化および営業体制の構築支援を通じて、
                  複数の企業における売上改善・収益基盤強化に従事。
                </p>
                <p>
                  現場視点に立った実行支援を重視し、継続的な成果創出を支援している。
                  理論だけでなく、実際の現場で機能する施策の立案・実行を得意としている。
                </p>
              </div>

            </div>
          </div>
        </div>
      </section>

      {/* Location */}
      <section className="py-20 bg-[#faf9f7]">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="mb-10">
            <span className="text-xs font-semibold tracking-[3px] text-gray-400 uppercase">Access</span>
            <h2 className="text-2xl md:text-3xl font-bold text-[#1a2332] mt-3">所在地案内</h2>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-start">
            <div>
              <div className="space-y-4 mb-6">
                {[
                  { icon: 'ri-map-pin-line', label: '住所', value: '〒116-0003\n東京都荒川区南千住8－6－2－1113' },
                  { icon: 'ri-train-line', label: '最寄駅', value: '南千住駅' },
                  { icon: 'ri-phone-line', label: '電話', value: '090-222-8377' },
                  { icon: 'ri-mail-line', label: 'メール', value: 'hayashi@y-f-s.jp' },
                ].map((item) => (
                  <div key={item.label} className="flex gap-3 bg-white rounded-xl px-5 py-4">
                    <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-[#1a2332]/10 flex-shrink-0">
                      <i className={`${item.icon} text-[#1a2332]`} />
                    </div>
                    <div>
                      <div className="text-xs text-gray-400">{item.label}</div>
                      <div className="text-sm text-[#1a2332] whitespace-pre-line mt-0.5">{item.value}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="rounded-2xl overflow-hidden h-80">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3239.1059041591507!2d139.79840507593866!3d35.73562097257775!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188e2a43aefce3%3A0x3a1fe0a56e5c8f9d!2z5Y2X5Y6u6Zmi5Y2X5Y6u77yI5L2P5Y6u6Zmi77yJ!5e0!3m2!1sja!2sjp!4v1699999999999!5m2!1sja!2sjp"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                title="Google Map - 南千住"
              />
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-[#1a2332]">
        <div className="max-w-7xl mx-auto px-6 md:px-10 text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">
            ご相談・お問い合わせはこちら
          </h2>
          <p className="text-white/60 mb-8">初回の無料相談を受け付けております。</p>
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 px-8 py-4 bg-white text-[#1a2332] font-semibold rounded-full hover:bg-white/90 transition-colors whitespace-nowrap cursor-pointer"
          >
            お問合せ <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
